export const DESKTOP_CATALOGUE = 'desktop-catalogue';
export const MOBILE_CATALOGUE = 'mobile-catalogue';
export const NEXT_CATALOGUE = 'next-catalogue';
export const CATALOGUE_IMAGE_ROOT = 'catalogue-image-root';
export const CATALOGUES_SEE_ALL = 'catalogues-see-all';
export const CATALOGUES_SEE_ALL_LINK = 'catalogues-see-all-link';
export const TITLE = 'title';
export const VALIDITY = 'validity';
export const LINK = 'link';
export const CTA_TEXT = 'cta-text';
export const PRODUCT_IMAGE = 'product-image';
export const DETAIL_BUTTON = 'detail-button';
